import { motion } from 'framer-motion';

/**
 * Divider between sections — a perforated line with small crop-tick
 * end-caps, not a plain solid rule. Ties into the "evidence record" visual
 * language already running through the page (the crop-marks motif on the
 * Pricing/Guides cards, the docket-style section headers): each section
 * reads as its own torn-off page from the same ledger, rather than a
 * generic content divider. Draws itself in left-to-right on scroll,
 * rather than just appearing — a cheap, one-line addition since the line
 * itself is the whole element.
 */
export default function SectionDivider() {
  return (
    <div aria-hidden="true" className="relative bg-black">
      <div className="max-w-6xl mx-auto px-6">
        <div className="relative h-6 flex items-center">
          <motion.span
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true, amount: 1 }}
            transition={{ duration: 0.3 }}
            className="absolute left-0 w-px h-2.5 bg-white/25"
          />
          <motion.div
            initial={{ scaleX: 0 }}
            whileInView={{ scaleX: 1 }}
            viewport={{ once: true, amount: 0.8 }}
            transition={{ duration: 0.7, ease: [0.22, 1, 0.36, 1] }}
            className="h-px w-full origin-left"
            style={{
              backgroundImage:
                'repeating-linear-gradient(90deg, rgba(255,255,255,0.16) 0px, rgba(255,255,255,0.16) 5px, transparent 5px, transparent 13px)',
            }}
          />
          <motion.span
            initial={{ opacity: 0 }}
            whileInView={{ opacity: 1 }}
            viewport={{ once: true, amount: 1 }}
            transition={{ duration: 0.3, delay: 0.6 }}
            className="absolute right-0 w-px h-2.5 bg-white/25"
          />
        </div>
      </div>
    </div>
  );
}
